import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-0NT38WY8F9');   // ← replace with your GA4 Measurement ID
};

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const logViewItem = (rigName: string) => {
  ReactGA.event({
    category: 'Rig',
    action: 'view_item',
    label: rigName,
  });
};

export const logLead = (formType: string = 'Contact') => {
  ReactGA.event({
    category: 'Lead',
    action: 'generate_lead',
    label: formType,
  });
};

export const logEvent = (params: {
  category: string;
  action: string;
  label?: string;
}) => {
  ReactGA.event({
    category: params.category,
    action: params.action,
    label: params.label,
  });
};